<template>
  <div>
    <div class="modal show fade modal text-left " style="display: block;" v-if="show">
      <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Update Status
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="validate-form mt-2">
                  <div class="row">
                    <div class="col-12 ">
                      <div class="form-group">
                        <label for="account-name">Status </label>
                        <select v-model="status" class="form-control">
                            <option value="0">Deactive</option>
                            <option value="1">Active</option>
                            <option value="2">Request For Changes</option>
                            <option value="3">Pending For Approval</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 ">
                      <div class="form-group">
                        <label for="account-name">Comments</label>
                        <textarea
                            type="text"
                            v-model="comments"
                            class="form-control"
                            :class="
                                  errorBag.has('comments') ? 'is-invalid' : ''
                                "
                            name="comments"
                            placeholder="comments"
                            v-validate="'required'"
                        />
                        <small
                            v-show="errorBag.has('comments')"
                            class="invalid-feedback"
                        >{{ "*" + errorBag.first("comments") }}</small
                        >
                      </div>
                    </div>
                  </div>
                </form>
          </div>
          <div class="modal-footer justify-content-center">
<!--            <button type="button" @click="sendCall" class="btn btn-primary mt-2 mr-1">Save changes</button>-->
            <button
                type="button"
                class="btn btn-primary mr-1 d-flex mt-2"
                @click="sendCall"
                :disabled="loading"
            >
              <Loader :loading="loading" size="10px"></Loader>
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ['show', 'row', 'index'],
  mounted() {
    // if(this.MerchantsData.length == 0){
    //   this.getMerchantData()
    // }

  },
  data() {
    return {
      list: [],
      MerchantsData:[],
      assignedTo:null,
      loading: false,
      comments: '',
      status: 1,
      subDepartments: [],
      selectedSubDepartment: null,
      selectedDepartment: null,
      getDepartmentsUrl: "v1/cms-get-department",
      // showModal: false,
    };
  },
  methods: {
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let data = {
            storeId:this.row?.id,
            status: this.status,
            comments: this.comments,
          }



          let url = 'v1/update-store-status'


          this.makeRequest("post", url, data).then(callResponse => {
            this.loading = false;
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                this.$emit('completed',callResponse.response.data.data)
              }
            }
          });
        }
      });
    },
  },
  watch: {
    show(val) {
      if(val){
        this.status = this.row?.status
      }
      this.$nextTick(() => {
        this.comments =  ''
      })
    },
  }
};
</script>

<style scoped>
.modal {
  display: block !important;
  /* I added this to see the modal, you don't need this */
}

/* Important part */
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}
</style>
